<template>
  <div class="ui-tab" :class="{ active: (id && active) || (!id && !active) }" @click="$emit('click', $event)">
    <slot></slot>
  </div>
</template>

<script setup>
defineOptions({ name: 'UiTab' })

defineEmits(['click'])

defineProps({
  id: {
    type: [String, Number],
    default: ''
  },
  active: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss" scoped>
.ui-tab {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  @include r(font-size, 26);
  z-index: 2;

  .label-box {
    .label-shadow {
      color: rgba(0, 0, 0, 0.4);
    }
    .label-text {
      color: #88A4E2;
    }
  }

  &.active .label-box .label-text {
    color: #FFFFFF;
  }
}
</style>
